class CoursePhotos extends HTMLElement {
  connectedCallback() {
    this.tiles = Array.from(this.querySelectorAll('.course-photos__grid [data-photo-index]'));
    this.dialog = this.querySelector('dialog');
    this.stage = this.querySelector('[data-photo-stage]');
    this.prev = this.querySelector('[data-photo-prev]');
    this.next = this.querySelector('[data-photo-next]');
    this.closeButton = this.querySelector('[data-photo-close]');
    this.thumbs = Array.from(this.querySelectorAll('[data-thumb-index]'));
    this.count = this.querySelector('[data-photo-count]');
    if (!this.dialog || !this.stage || !this.tiles.length) return;

    this.index = 0;
    this.swipeX = null;
    this.wheelLock = false;

    this.onKeydown = (event) => {
      if (!this.dialog.open) return;
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.step(1);
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.step(-1);
      }
    };

    this.addEventListener('click', (event) => {
      const thumb = event.target.closest('[data-thumb-index]');
      if (thumb && this.contains(thumb)) {
        this.open(Number(thumb.dataset.thumbIndex));
        return;
      }

      const tile = event.target.closest('.course-photos__grid [data-photo-index]');
      if (!tile || !this.contains(tile)) return;
      this.open(Number(tile.dataset.photoIndex));
    });
    this.prev?.addEventListener('click', () => this.step(-1));
    this.next?.addEventListener('click', () => this.step(1));
    this.closeButton?.addEventListener('click', () => this.dialog.close());
    this.dialog.addEventListener('close', () => {
      this.pauseCurrent();
      this.stage.replaceChildren();
    });
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dialog.close();
    });

    this.stage.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (event.target.closest('video, iframe')) {
        this.swipeX = null;
        return;
      }
      this.swipeX = event.clientX;
    });
    this.stage.addEventListener('pointerup', (event) => {
      if (this.swipeX == null) return;
      const delta = event.clientX - this.swipeX;
      this.swipeX = null;
      if (Math.abs(delta) < 40) return;
      this.step(delta < 0 ? 1 : -1);
    });
    this.stage.addEventListener('pointercancel', () => {
      this.swipeX = null;
    });
    this.stage.addEventListener(
      'wheel',
      (event) => {
        if (!this.dialog.open) return;
        if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
        event.preventDefault();
        if (this.wheelLock) return;
        if (Math.abs(event.deltaX) < 12) return;
        this.wheelLock = true;
        this.step(event.deltaX > 0 ? 1 : -1);
        window.setTimeout(() => {
          this.wheelLock = false;
        }, 280);
      },
      { passive: false }
    );

    document.addEventListener('keydown', this.onKeydown);
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.onKeydown);
  }

  open(index) {
    this.index = index;
    this.show();
    if (!this.dialog.open) this.dialog.showModal();
  }

  step(direction) {
    const count = this.tiles.length;
    this.index = (this.index + direction + count) % count;
    this.show();
  }

  pauseCurrent() {
    this.stage.querySelectorAll('video').forEach((video) => {
      video.pause();
    });
    this.stage.querySelectorAll('iframe').forEach((frame) => {
      frame.src = '';
    });
  }

  updateThumbs() {
    this.thumbs.forEach((thumb, index) => {
      const current = index === this.index;
      thumb.classList.toggle('is-current', current);
      if (current) {
        thumb.setAttribute('aria-current', 'true');
      } else {
        thumb.removeAttribute('aria-current');
      }
    });
    const scroller = this.querySelector('[data-photo-thumbs]');
    const currentThumb = this.thumbs[this.index];
    if (scroller && currentThumb) {
      const left = currentThumb.offsetLeft - scroller.clientWidth / 2 + currentThumb.clientWidth / 2;
      scroller.scrollTo({ left, behavior: 'smooth' });
    }
    if (this.count) {
      this.count.textContent = `${this.index + 1} / ${this.tiles.length}`;
    }
  }

  show() {
    const tile = this.tiles[this.index];
    this.pauseCurrent();
    this.stage.replaceChildren();
    this.updateThumbs();
    if (!tile) return;

    const type = tile.dataset.type;
    const alt = tile.dataset.alt || '';

    if (type === 'image') {
      const image = document.createElement('img');
      image.src = tile.dataset.src;
      image.alt = alt;
      this.stage.append(image);
      return;
    }

    if (type === 'external') {
      const frame = document.createElement('iframe');
      const id = tile.dataset.externalId;
      frame.src =
        tile.dataset.host === 'vimeo'
          ? `https://player.vimeo.com/video/${id}`
          : `https://www.youtube.com/embed/${id}?rel=0`;
      frame.title = alt || 'Video';
      frame.allow = 'autoplay; encrypted-media; fullscreen';
      frame.allowFullscreen = true;
      this.stage.append(frame);
      return;
    }

    const template = tile.querySelector('[data-photo-player]');
    if (template) {
      this.stage.append(template.content.cloneNode(true));
      const video = this.stage.querySelector('video');
      if (video) {
        video.controls = true;
        video.playsInline = true;
        const play = video.play();
        if (play?.catch) play.catch(() => {});
      }
    }
  }
}

if (!customElements.get('course-photos')) {
  customElements.define('course-photos', CoursePhotos);
}
